import React, { useState } from "react";
import { fetchSampleTypeVoilImage } from "services/sampleTypeMaster";
import { STALE_TIME } from "utils/constants";
import { useQuery } from "@tanstack/react-query";

const Details = ({ item }) => {
  console.log("item", item);
  const [imageError, setImageError] = useState(false);

  const { data: voilImageData } = useQuery(
    ["fetch-voil-image", item?.sample_types_objs[0]?.sample_type_id],
    () => fetchSampleTypeVoilImage(item?.sample_types_objs[0]?.sample_type_id),
    {
      staleTime: STALE_TIME,
      enabled: !!item?.sample_types_objs[0]?.sample_type_id,
      onError: (error) => {
        console.error("Error fetching profile picture:", error);
      },
    }
  );

  if (!item) return null;

  const imageData = voilImageData?.data;

  // Helper functions for file handling
  const getFileType = (base64Data) => {
    if (!base64Data) return "unknown";

    if (base64Data.startsWith("JVBERi0x")) return "pdf";
    if (base64Data.startsWith("/9j/") || base64Data.startsWith("iVBORw0KGgo"))
      return "image";
    if (base64Data.startsWith("R0lGODlh")) return "gif";
    if (base64Data.startsWith("UklGRg")) return "webp";

    return "image";
  };

  const getDataUrl = (base64Data) => {
    if (!base64Data) return null;

    const fileType = getFileType(base64Data);

    if (fileType === "pdf") {
      return `data:application/pdf;base64,${base64Data}`;
    } else {
      return `data:image/jpeg;base64,${base64Data}`;
    }
  };

  const downloadFile = (base64Data, filename = "voil-document") => {
    const fileType = getFileType(base64Data);
    const dataUrl = getDataUrl(base64Data);

    const link = document.createElement("a");
    link.href = dataUrl;

    if (fileType === "pdf") {
      link.download = `${filename}.pdf`;
    } else {
      link.download = `${filename}.jpg`;
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fileType = imageData ? getFileType(imageData) : null;

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <tbody>
          <tr>
            <th>Investigation Name</th>
            <td>{item.investigation_name}</td>
          </tr>
          <tr>
            <th>Sample Type</th>
            <td>{item.sample_types_objs?.[0]?.sample_type_name || "N/A"}</td>
          </tr>
          <tr>
            <th>Lab Department</th>
            <td>{item.lab_department_name}</td>
          </tr>
          <tr>
            <th>Rate</th>
            <td>₹{item.rate}</td>
          </tr>
          <tr>
            <th>MRP</th>
            <td>₹{item.mrp_rate}</td>
          </tr>
          <tr>
            <th>Processing Days</th>
            <td>{item.processing_days}</td>
          </tr>
          <tr>
            <th>Delivery Days</th>
            <td>{item.day_off?.filter(Boolean).join(", ") || "N/A"}</td>
          </tr>
          {imageData && (
            <tr>
              <th>Sample Voil Image/Document</th>
              <td>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <span className="fw-semibold">Uploaded Document:</span>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success"
                      onClick={() =>
                        downloadFile(
                          imageData,
                          `sample-${item?.sample_types_objs[0]?.sample_type_name}`
                        )
                      }
                    >
                      📥 Download
                    </button>
                    {fileType === "pdf" && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          window.open(getDataUrl(imageData), "_blank")
                        }
                      >
                        🔍 Open PDF
                      </button>
                    )}
                  </div>
                </div>

                <div className="border p-2 bg-light rounded">
                  {fileType === "pdf" ? (
                    <div>
                      <div className="text-center mb-2">
                        <div style={{ fontSize: "2rem", color: "#dc3545" }}>
                          📄
                        </div>
                        <p className="mb-2 fw-semibold">PDF Document</p>
                      </div>
                      {/* PDF Preview using iframe */}
                      <div
                        style={{
                          height: "300px",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                        }}
                      >
                        <iframe
                          src={getDataUrl(imageData)}
                          width="100%"
                          height="100%"
                          style={{ border: "none", borderRadius: "4px" }}
                          title="PDF Preview"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="text-center">
                      {!imageError ? (
                        <img
                          src={getDataUrl(imageData)}
                          alt="Sample Document"
                          className="img-fluid"
                          style={{ maxHeight: "300px", maxWidth: "100%" }}
                          onError={() => setImageError(true)}
                        />
                      ) : (
                        <div>
                          <div style={{ fontSize: "3rem", color: "#28a745" }}>
                            🖼️
                          </div>
                          <p className="mb-2">Image Document</p>
                          <p className="text-muted small">
                            Preview not available
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Details;
